var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigWesoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 462,
    viewBox: "0 0 1440 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.629 234.603V230.541C501.629 145.373 565.007 91.6221 645.152 91.6221C717.649 91.6221 780.009 133.21 780.009 228.513C780.012 231.639 779.398 234.739 778.204 237.629C777.008 240.519 775.256 243.148 773.047 245.362C770.835 247.576 768.21 249.332 765.32 250.531C762.433 251.729 759.335 252.35 756.206 252.352H593.43C595.967 287.356 616.184 307.624 648.687 307.624C669.042 307.624 681.417 301.289 688.367 291.645C691.859 286.84 696.441 282.933 701.739 280.246C707.037 277.559 712.898 276.168 718.838 276.189C755.262 276.189 770.717 322.764 741.399 344.45C718.751 361.147 686.651 370.056 645.659 370.056C562.539 369.969 501.629 321.294 501.629 234.603ZM691.743 201.139C690.239 169.194 674.521 151.447 645.116 151.447C617.742 151.447 598.978 169.194 594.358 201.139H691.743Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.152 90.5059C681.604 90.5059 715.609 100.962 740.516 123.502C765.441 146.059 781.125 180.603 781.125 228.512C781.127 231.58 780.563 234.624 779.463 237.485L779.235 238.056C778.062 240.891 776.377 243.488 774.265 245.711L773.836 246.15C771.665 248.323 769.115 250.075 766.311 251.319L765.748 251.562C762.725 252.816 759.483 253.465 756.207 253.468H594.64C596.062 270.205 601.626 283.333 610.611 292.326C619.8 301.523 632.677 306.509 648.687 306.509C668.805 306.509 680.784 300.259 687.462 290.993L687.464 290.989C691.06 286.042 695.778 282.018 701.234 279.251C706.69 276.484 712.724 275.052 718.842 275.072C756.333 275.075 772.249 323.018 742.062 345.347L742.06 345.348C719.159 362.233 686.797 371.172 645.658 371.172H645.657C603.886 371.128 567.593 358.874 541.728 335.636C515.848 312.383 500.513 278.226 500.513 234.603V230.541C500.513 187.664 516.474 152.633 542.576 128.327C568.669 104.029 604.831 90.5059 645.152 90.5059ZM645.116 152.563C631.684 152.564 620.439 156.91 611.981 165.114C603.74 173.108 598.063 184.847 595.658 200.022H690.565C689.67 184.777 685.44 173.04 678.073 165.071C670.539 156.922 659.585 152.563 645.116 152.563Z",
    stroke: "white",
    strokeWidth: 2.2317
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.003 279.849H863.586C869.574 279.943 875.441 281.547 880.643 284.515C885.845 287.483 890.213 291.719 893.339 296.825C898.785 305.261 908.305 309.76 925.108 309.76C947.407 309.76 957.559 301.13 957.559 287.952C957.559 275.281 944.885 269.188 908.374 264.131C837.402 254.994 807.488 234.217 807.488 178.962C807.488 120.152 859.701 91.7451 921.048 91.7451C952.553 91.7451 979.595 96.9963 999.81 109.458C1031.17 128.957 1017.12 177.438 980.188 177.438C974.415 177.539 968.7 176.255 963.524 173.693C958.347 171.134 953.859 167.369 950.435 162.72C944.992 154.896 936.099 151.062 922.238 151.062C902.46 151.062 892.324 159.692 892.324 171.857C892.324 184.528 904.576 189.603 936.94 193.665C1010.45 202.784 1045.95 222.054 1045.95 278.833C1045.95 341.703 999.303 370.092 925.791 370.092C887.004 370.092 856.514 361.797 835.739 345.78C807.682 324.358 822.909 279.849 858.003 279.849Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.048 90.6289C952.159 90.6289 979.078 95.7292 999.431 107.922L1000.4 108.508L1000.4 108.511C1032.73 128.608 1018.23 178.537 980.207 178.553L980.208 178.554C974.256 178.657 968.364 177.335 963.029 174.693V174.692C957.692 172.054 953.065 168.173 949.537 163.382L949.528 163.369L949.519 163.357C944.36 155.941 935.889 152.178 922.238 152.178C912.493 152.178 905.276 154.306 900.525 157.797C895.812 161.26 893.44 166.121 893.44 171.856C893.44 174.832 894.155 177.29 895.653 179.392C897.162 181.509 899.528 183.352 902.972 184.98C909.901 188.256 920.89 190.526 937.079 192.558H937.078C973.856 197.12 1001.36 204.239 1019.66 217.472C1038.08 230.782 1047.06 250.172 1047.06 278.833C1047.06 310.581 1035.26 333.754 1014.09 348.945C992.969 364.093 962.662 371.208 925.791 371.208C886.868 371.208 856.101 362.887 835.058 346.664V346.663C806.154 324.589 821.849 278.733 858.003 278.733H863.604C869.779 278.83 875.831 280.485 881.196 283.546C886.554 286.603 891.053 290.964 894.277 296.221L894.521 296.592C899.719 304.347 908.76 308.645 925.108 308.645C936.14 308.644 943.986 306.506 949.047 302.891C954.051 299.315 956.443 294.217 956.443 287.952C956.443 284.985 955.707 282.465 954.104 280.249C952.488 278.015 949.935 276.01 946.172 274.19C938.614 270.535 926.476 267.765 908.221 265.236V265.235C872.704 260.662 847.217 253.157 830.614 239.708C813.922 226.188 806.372 206.807 806.372 178.962C806.372 149.175 819.619 127.036 840.625 112.385C861.588 97.7635 890.223 90.6289 921.048 90.6289Z",
    stroke: "white",
    strokeWidth: 2.2317
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1070 234.481V230.421C1070 145.251 1133.37 91.5 1215.51 91.5C1297.13 91.5 1360 143.729 1360 227.882V231.943C1360 318.127 1296.62 369.829 1215.01 369.829C1133.39 369.829 1070 320.158 1070 234.481ZM1267.78 232.959V228.897C1267.78 184.283 1250.03 159.446 1215.57 159.446C1181.6 159.446 1162.83 183.268 1162.83 227.882V231.943C1162.83 277.573 1180.58 302.41 1215.57 302.41C1249.47 302.41 1267.73 277.066 1267.73 232.959H1267.78Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.52 90.3838C1256.56 90.3838 1292.96 103.518 1319.11 127.308C1345.28 151.108 1361.12 185.51 1361.12 227.882V231.943C1361.12 275.326 1345.16 310.105 1318.86 334.03C1292.58 357.944 1256.05 370.945 1215.01 370.945C1173.98 370.945 1137.45 358.459 1111.16 335.118C1084.85 311.764 1068.88 277.614 1068.88 234.48V230.422C1068.88 187.544 1084.84 152.509 1111.2 128.201C1137.54 103.903 1174.2 90.3838 1215.52 90.3838ZM1215.57 160.562C1198.87 160.562 1186.03 166.401 1177.34 177.617C1168.61 188.879 1163.95 205.707 1163.95 227.882V231.943C1163.95 254.642 1168.37 271.983 1176.98 283.624C1185.54 295.208 1198.37 301.294 1215.57 301.294C1232.21 301.294 1244.9 295.094 1253.46 283.56C1262.07 271.975 1266.61 254.883 1266.61 232.959V231.843H1266.66V228.897C1266.66 206.711 1262.25 189.623 1253.7 178.106C1245.2 166.645 1232.5 160.563 1215.57 160.562Z",
    stroke: "white",
    strokeWidth: 2.2317
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.379 132.65C493.316 114.185 472.102 137.901 462.003 171.785L404.979 333.896C388.772 375.904 323.363 380.298 303.235 336.137L276.403 253.401L242.78 345.117C231.036 373.121 172.331 383.132 148.843 335.052L83.3119 142.521L80.8441 135.31C80.2873 132.757 80.0056 130.153 80.0039 127.539C79.8837 119.485 82.569 111.638 87.5995 105.347C92.6299 99.0561 99.6922 94.7087 107.576 93.0528C115.459 91.3991 123.673 92.5372 130.809 96.2731C137.946 100.011 143.56 106.113 146.69 113.535L147.127 114.622C147.137 114.685 147.137 114.749 147.127 114.814L202.436 251.109L236.619 143.833C262.873 79.0734 322.872 74.4872 349.128 136.517L373.018 207.019L388.123 162.86C398.73 131.967 413.205 110.194 431.723 97.9938C470.859 82.8896 494.365 100.48 503.379 132.65Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.11 91.8091C116.012 90.3298 124.192 91.5492 131.327 95.2847L132.013 95.6538C138.825 99.4127 144.229 105.286 147.407 112.387L147.718 113.102L147.722 113.11L147.725 113.119L148.162 114.206L148.211 114.325L148.23 114.453C148.238 114.503 148.242 114.553 148.245 114.603L202.31 247.83L235.556 143.495L235.569 143.454L235.585 143.414C248.805 110.804 270.654 93.0438 292.796 91.5161C314.644 90.0088 336.226 104.334 349.528 134.627L350.155 136.083L350.172 136.121L350.185 136.16L373.023 203.556L387.066 162.5L387.067 162.499C397.716 131.485 412.303 109.452 431.109 97.062L431.21 96.9956L431.321 96.9526C451.092 89.3221 467.115 89.88 479.384 96.6157C491.631 103.34 499.898 116.09 504.453 132.349L502.399 133.184C500.017 128.813 497.145 127.193 494.138 127.325C490.994 127.463 487.336 129.516 483.495 133.374C475.848 141.053 468.091 155.263 463.072 172.104L463.064 172.129L463.056 172.156L406.031 334.266L406.02 334.297C397.726 355.793 376.872 367.601 355.622 368.445C334.354 369.289 312.502 359.16 302.22 336.599L302.193 336.542L302.174 336.481L276.338 256.817L243.827 345.501L243.818 345.525L243.809 345.548C237.708 360.096 219.583 369.739 200.215 369.732C180.742 369.725 159.785 359.994 147.84 335.542L147.809 335.479L147.786 335.412L82.2559 142.881L79.7881 135.671L79.7676 135.611L79.7539 135.548C79.1813 132.923 78.8906 130.244 78.8877 127.556L78.8848 126.777C78.9396 118.738 81.6977 110.94 86.7275 104.65C91.9196 98.1566 99.2096 93.6696 107.347 91.9604L108.11 91.8091Z",
    stroke: "white",
    strokeWidth: 2.2317
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1_442",
    x: 410.129,
    y: 0.121939,
    width: 461.38,
    height: 461.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 22.317,
    dy: 22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -22.317,
    dy: -22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_442",
    result: "effect2_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1_442",
    x: 715.988,
    y: 0.244986,
    width: 421.46,
    height: 461.347,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 22.317,
    dy: 22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -22.317,
    dy: -22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_442",
    result: "effect2_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1_442",
    x: 978.497,
    y: -0.000131607,
    width: 473.003,
    height: 461.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 22.317,
    dy: 22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -22.317,
    dy: -22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_442",
    result: "effect2_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1_442",
    x: -11.4999,
    y: 0.812857,
    width: 606.296,
    height: 459.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 22.317,
    dy: 22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -22.317,
    dy: -22.317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.4756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_442",
    result: "effect2_dropShadow_1_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWesoLogo);
export default __webpack_public_path__ + "static/media/big-weso-logo.411b95825b4e0e1d6aaed0375b934d42.svg";
export { ForwardRef as ReactComponent };